import { defineMessages } from 'react-intl-next';

export const normalizeSeatModalMessages: {
	administrationLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	appTilesAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmationTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamworkCollectionAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	toggleText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	toggleWarning: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	confirmationTitle: {
		id: 'twc.normalize-seat-modal.confirmation.title',
		defaultMessage: 'Give your teammates access to all Teamwork Collection apps',
		description: 'Title for the seat normalization confirmation screen',
	},
	confirmationDescription: {
		id: 'twc.normalize-seat-modal.confirmation.description',
		defaultMessage: 'You can update permissions anytime in {link}.',
		description: 'Description for the seat normalization confirmation screen',
	},
	toggleText: {
		id: 'twc.normalize-seat-modal.toggle.text',
		defaultMessage: 'Grant access',
		description: 'Text for the toggle switch',
	},
	confirmButton: {
		id: 'twc.normalize-seat-modal.confirmation.try-now',
		defaultMessage: 'Confirm',
		description: 'Button text to confirm seat optimization',
	},
	toggleWarning: {
		id: 'twc.normalize-seat-modal.toggle.warning',
		defaultMessage: "Turning this off means your team won't get access.",
		description: 'Warning message when toggle is turned off',
	},
	administrationLink: {
		id: 'twc.normalize-seat-modal.confirmation.administration-link',
		defaultMessage: 'Atlassian Administration',
		description: 'Link text for Atlassian Administration',
	},
	appTilesAlt: {
		id: 'twc.normalize-seat-modal.app-tiles.alt',
		defaultMessage: 'App tiles completion illustration',
		description: 'Alt text for the app tiles illustration',
	},
	teamworkCollectionAlt: {
		id: 'twc.xflow.modal.teamwork.collection.alt',
		defaultMessage: 'Teamwork collection illustration',
		description: 'Alt text for teamwork collection illustration',
	},
});
